import React, { Fragment, useContext, useEffect, useState } from 'react'
import { CarOrderingContext } from "../../CarOrdering";

export default function ErrorMessage({ field, scrollToTop = false }) {
  const {
    errors,
  } = useContext(CarOrderingContext)

  const [display, setDisplay] = useState(false)

  useEffect(() => {
    const _display = (typeof errors[field] === 'string' && errors[field].length > 0) ||
      (Array.isArray(errors[field]) && errors[field].length > 0)
    setDisplay(_display)

    if (_display && scrollToTop !== undefined && scrollToTop) {
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
    }
  }, [errors])

  if (!display) {
    return null
  }

  const errorMessages = () => {
    if (typeof errors[field] === 'string') {
      return errors[field]
    }

    if (! Array.isArray(errors[field])) {
      return null
    }

    return errors[field].map((error, index) => {
      return (
        <Fragment key={index}>
          {error}<br />
        </Fragment>
      )
    })
  }

  return (
    <div className='validation-error'>
      {errorMessages()}
    </div>
  )
}
